(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Category Drawer Trigger
    const categoryDrawerTrigger = document.getElementById('CategoryDrawerTrigger');
    const categoryDrawer = document.getElementById('CategoryDrawer');

    if (categoryDrawerTrigger && categoryDrawer) {
      categoryDrawerTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        categoryDrawer.open();
      });
    }

    const navLinks = document.querySelectorAll('.collections-content__nav-link');
    const collections = document.querySelectorAll('.collections-content__collection');
    const mainContent = document.querySelector('.collections-content__main');
    const isCategoryPage = mainContent && mainContent.classList.contains('collections-content__main--category');

    function setActiveLink(collectionId) {
      // Don't set active state on category collection pages
      if (isCategoryPage) {
        navLinks.forEach((link) => {
          link.classList.remove('active');
        });
        return;
      }

      navLinks.forEach((link) => {
        link.classList.remove('active');
        if (link.getAttribute('data-collection') === collectionId) {
          link.classList.add('active');
        }
      });
    }

    function updateActiveLink() {
      // Don't update active state on category collection pages
      if (isCategoryPage) {
        navLinks.forEach((link) => {
          link.classList.remove('active');
        });
        return;
      }

      if (collections.length === 0) return;

      const headerHeight = 65;
      const threshold = headerHeight + 100;
      let activeCollection = null;
      let closestDistance = Infinity;

      collections.forEach((collection) => {
        const collectionElement = document.getElementById(collection.id);
        if (!collectionElement) return;

        const headline = collectionElement.querySelector('.collections-content__collection-headline');
        if (!headline) return;

        const rect = headline.getBoundingClientRect();
        const collectionTop = rect.top;
        const collectionId = collection.id.replace('collection-', '');

        if (collectionTop <= threshold) {
          const distance = Math.abs(collectionTop - threshold);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeCollection = collectionId;
          }
        }
      });

      if (activeCollection) {
        setActiveLink(activeCollection);
      } else {
        // If no collection is active, activate the first link
        // Only if we have multiple collections (list view)
        if (collections.length > 1 && navLinks.length > 0) {
          navLinks.forEach((link) => {
            link.classList.remove('active');
          });
          navLinks[0].classList.add('active');
        }
      }
    }

    // Smooth scroll for anchor links
    navLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        const sectionTarget = this.getAttribute('data-section');
        const collectionTarget = this.getAttribute('data-collection');

        let targetElement;
        if (sectionTarget) {
          targetElement = document.getElementById(sectionTarget);
        } else if (collectionTarget) {
          targetElement = document.getElementById('collection-' + collectionTarget);
        }

        // Only prevent default and handle scrolling if target exists on current page
        if (targetElement) {
          e.preventDefault();
          const headline = targetElement.querySelector(
            '.collections-content__headline, .collections-content__collection-headline'
          );
          if (headline) {
            const headerOffset = 65;
            const isMobile = window.innerWidth <= 768;
            const spacingSection = isMobile ? 32 : 64;
            const elementPosition = headline.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset - spacingSection;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });

            const hash = sectionTarget ? '#' + sectionTarget : '#collection-' + collectionTarget;
            history.pushState(null, null, hash);
          }
        }
        // If target doesn't exist, let browser handle navigation naturally
      });
    });

    // Throttle scroll events for better performance
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateActiveLink();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Handle hash on page load
    if (!isCategoryPage) {
      if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        if (hash.startsWith('collection-')) {
          const collectionId = hash.replace('collection-', '');
          setActiveLink(collectionId);
        } else if (hash === 'collections-section') {
          setActiveLink('collections-section');
        }
      } else {
        updateActiveLink();
      }
    } else {
      // Remove any active states on category pages
      navLinks.forEach((link) => {
        link.classList.remove('active');
      });
    }

    // Update when hash changes
    window.addEventListener('hashchange', function () {
      // Don't set active states on category collection pages
      if (isCategoryPage) {
        navLinks.forEach((link) => {
          link.classList.remove('active');
        });
        return;
      }

      const hash = window.location.hash.substring(1);
      if (hash.startsWith('collection-')) {
        const collectionId = hash.replace('collection-', '');
        setActiveLink(collectionId);
        const targetCollection = document.getElementById('collection-' + collectionId);
        if (targetCollection) {
          const headline = targetCollection.querySelector('.collections-content__collection-headline');
          if (headline) {
            const headerOffset = 65;
            const isMobile = window.innerWidth <= 768;
            const spacingSection = isMobile ? 32 : 64;
            const elementPosition = headline.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset - spacingSection;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }
        }
      } else if (hash === 'collections-section') {
        setActiveLink('collections-section');
        const targetSection = document.getElementById('collections-section');
        if (targetSection) {
          const headline = targetSection.querySelector('.collections-content__headline');
          if (headline) {
            const headerOffset = 65;
            const isMobile = window.innerWidth <= 768;
            const spacingSection = isMobile ? 32 : 64;
            const elementPosition = headline.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset - spacingSection;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }
        }
      }
    });
  })();

  (function () {
    // Close category drawer when category links are clicked
    const categoryDrawer = document.getElementById('CategoryDrawer');
    const categoryLinks = document.querySelectorAll('[data-category-drawer-close]');

    if (categoryDrawer && categoryLinks.length > 0) {
      categoryLinks.forEach((link) => {
        link.addEventListener('click', function () {
          if (categoryDrawer.isOpen) {
            categoryDrawer.close();
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Initialize cart drawer triggers
    function initCartDrawer() {
      const cartDrawer = document.querySelector('[data-cart-drawer]');
      const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

      if (!cartDrawer) return;

      cartTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          cartDrawer.open();
        });
      });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawer);
    } else {
      initCartDrawer();
    }
  })();

  (function () {
    // Copy footer links to mobile menu footer
    function copyFooterLinks() {
      const footer = document.querySelector('footer:not(.header__mobile-footer)');
      const footerLinks = footer ? footer.querySelector('.footer__links') : null;
      const mobileFooterLinks = document.querySelector('.header__mobile-footer .footer__links');

      if (footerLinks && mobileFooterLinks) {
        const linksHTML = footerLinks.innerHTML.trim();
        if (linksHTML) {
          mobileFooterLinks.innerHTML = linksHTML;
          return true;
        }
      }
      return false;
    }

    // Try to copy links immediately
    if (copyFooterLinks()) {
      // Success, links copied
    } else {
      // Footer not ready yet, wait and retry
      let attempts = 0;
      const maxAttempts = 20;

      const retryCopy = setInterval(function () {
        attempts++;
        if (copyFooterLinks() || attempts >= maxAttempts) {
          clearInterval(retryCopy);
        }
      }, 250);

      // Also watch for footer to be added to DOM
      const observer = new MutationObserver(function (mutations) {
        if (copyFooterLinks()) {
          observer.disconnect();
          clearInterval(retryCopy);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Also try when menu opens (in case footer loads very late)
      const mobileDrawer = document.querySelector('mobile-drawer');
      if (mobileDrawer) {
        mobileDrawer.addEventListener('drawer:open', function () {
          setTimeout(copyFooterLinks, 300);
        });
      }
    }
  })();

  (function () {
    // Update menu button text when drawer opens/closes
    function initMenuButtonText() {
      const mobileDrawer = document.querySelector('mobile-drawer');
      const menuButton = document.querySelector('.header__mobile-menu-toggle[data-drawer-trigger]');

      if (!mobileDrawer || !menuButton) return;

      const menuText = menuButton.getAttribute('data-menu-text') || 'Menu';
      const closeText = menuButton.getAttribute('data-close-text') || 'Close';

      function updateButtonText(isOpen) {
        menuButton.textContent = isOpen ? closeText : menuText;
      }

      // Listen for drawer open/close events
      mobileDrawer.addEventListener('drawer:open', function () {
        updateButtonText(true);
      });

      mobileDrawer.addEventListener('drawer:close', function () {
        updateButtonText(false);
      });

      // Initialize button text based on current state
      const isExpanded = menuButton.getAttribute('aria-expanded') === 'true';
      updateButtonText(isExpanded);
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMenuButtonText);
    } else {
      initMenuButtonText();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
